import React from 'react';
import {
    CollapsibleInnerDiv, CustomLink,
    CollapsibleInnerUnderlineGray,
    CollapsibleTwoInnerSubHeader,
    CollapsibleTwoSubOuterDiv
} from '../ServicePageContainer';

export class MenuSubItemComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
        this.togglePanel = this.togglePanel.bind(this);
    }

    togglePanel(e) {
        this.setState({ open: !this.state.open });
    }

    render() {
        const { menuSubItem, url, lengthSubMenuList, index } = this.props;

        return (
            <>
                <CollapsibleTwoSubOuterDiv onClick={e => this.togglePanel(e)} style={{ backgroundColor: 'white' }}>
                    <CollapsibleInnerDiv>
                        <CollapsibleTwoInnerSubHeader> <CustomLink nounderline to={url[0]}>
                            {menuSubItem.name}
                        </CustomLink></CollapsibleTwoInnerSubHeader>
                    </CollapsibleInnerDiv>
                </CollapsibleTwoSubOuterDiv>
                {index < lengthSubMenuList ? <CollapsibleInnerUnderlineGray />
                    : ''}
            </>
        );
    }
};
